export default {
  install(Vue){
    Vue.config.globalProperties.fnedu_version = "3.2.109";
  }
}
